import * as React from 'react'

function NotFoundIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={93.876} height={51.573} viewBox="0 0 93.876 51.573" {...props}>
      <g data-name="Group 112" transform="translate(-875.057 -558.577)">
        <path
          data-name="Line 209"
          transform="translate(875.557 609.65)"
          fill="none"
          stroke="#1a1818"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M0 0L92.876 0"
        />
        <path
          data-name="Path 899"
          d="M2357.382 330.411h-.075l-7.7 12h7.775zm.55 12.5v4.6h-.55v-4.6h-8.275v-.675l7.975-12.425h.85v12.6h2.95v.5z"
          transform="translate(-1447 246)"
          fill="#ea3e3b"
        />
        <path
          data-name="Path 900"
          d="M2369.032 330.011a3.847 3.847 0 00-1.925.45 4.909 4.909 0 00-1.375 1.2 6.275 6.275 0 00-.875 1.675 13.341 13.341 0 00-.5 1.9 12.733 12.733 0 00-.225 1.875c-.025.6-.05 1.125-.05 1.55 0 .45.025.975.05 1.55a12.031 12.031 0 00.225 1.85 12.52 12.52 0 00.5 1.9 5.918 5.918 0 00.875 1.675 4.227 4.227 0 001.375 1.2 3.607 3.607 0 001.925.475 3.759 3.759 0 001.95-.475 4.41 4.41 0 001.35-1.2 5.918 5.918 0 00.875-1.675 12.52 12.52 0 00.5-1.9 12.031 12.031 0 00.225-1.85c.025-.575.05-1.1.05-1.55 0-.425-.025-.95-.05-1.55a12.733 12.733 0 00-.225-1.875 13.341 13.341 0 00-.5-1.9 6.275 6.275 0 00-.875-1.675 5.173 5.173 0 00-1.35-1.2 4.013 4.013 0 00-1.95-.45m0 17.8a4.194 4.194 0 01-2.775-.875 5.783 5.783 0 01-1.675-2.175 10.653 10.653 0 01-.825-2.95 22.153 22.153 0 010-6.3 10.653 10.653 0 01.825-2.95 5.868 5.868 0 011.675-2.2 4.954 4.954 0 015.55 0 5.868 5.868 0 011.675 2.2 10.653 10.653 0 01.825 2.95 22.153 22.153 0 010 6.3 10.653 10.653 0 01-.825 2.95 5.783 5.783 0 01-1.675 2.175 4.194 4.194 0 01-2.775.875"
          transform="translate(-1447 246)"
          fill="#ea3e3b"
        />
        <path
          data-name="Path 901"
          d="M2385.382 330.411h-.075l-7.7 12h7.775zm.55 12.5v4.6h-.55v-4.6h-8.275v-.675l7.975-12.425h.85v12.6h2.95v.5z"
          transform="translate(-1447 246)"
          fill="#ea3e3b"
        />
        <path
          data-name="Path 902"
          d="M910.382 576.411h-.075l-7.7 12h7.775zm.55 12.5v4.6h-.55v-4.6h-8.275v-.675l7.975-12.425h.85v12.6h2.95v.5z"
          fill="none"
          stroke="#ea3e3b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.6}
        />
        <path
          data-name="Path 903"
          d="M922.032 576.011a3.847 3.847 0 00-1.925.45 4.909 4.909 0 00-1.375 1.2 6.275 6.275 0 00-.875 1.675 13.341 13.341 0 00-.5 1.9 12.733 12.733 0 00-.225 1.875c-.025.6-.05 1.125-.05 1.55 0 .45.025.975.05 1.55a12.031 12.031 0 00.225 1.85 12.52 12.52 0 00.5 1.9 5.918 5.918 0 00.875 1.675 4.227 4.227 0 001.375 1.2 3.607 3.607 0 001.925.475 3.759 3.759 0 001.95-.475 4.41 4.41 0 001.35-1.2 5.918 5.918 0 00.875-1.675 12.52 12.52 0 00.5-1.9 12.031 12.031 0 00.225-1.85c.025-.575.05-1.1.05-1.55 0-.425-.025-.95-.05-1.55a12.733 12.733 0 00-.225-1.875 13.341 13.341 0 00-.5-1.9 6.275 6.275 0 00-.875-1.675 5.173 5.173 0 00-1.35-1.2 4.013 4.013 0 00-1.95-.45zm0 17.8a4.194 4.194 0 01-2.775-.875 5.783 5.783 0 01-1.675-2.175 10.653 10.653 0 01-.825-2.95 22.153 22.153 0 010-6.3 10.653 10.653 0 01.825-2.95 5.868 5.868 0 011.675-2.2 4.954 4.954 0 015.55 0 5.868 5.868 0 011.675 2.2 10.653 10.653 0 01.825 2.95 22.153 22.153 0 010 6.3 10.653 10.653 0 01-.825 2.95 5.783 5.783 0 01-1.675 2.175 4.194 4.194 0 01-2.775.875z"
          fill="none"
          stroke="#ea3e3b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.6}
        />
        <path
          data-name="Path 904"
          d="M938.382 576.411h-.075l-7.7 12h7.775zm.55 12.5v4.6h-.55v-4.6h-8.275v-.675l7.975-12.425h.85v12.6h2.95v.5z"
          fill="none"
          stroke="#ea3e3b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.6}
        />
        <path
          data-name="Line 231"
          transform="translate(892.036 568.024)"
          fill="none"
          stroke="#1a1818"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.994}
          d="M59.911 0L0 0"
        />
        <path
          data-name="Rectangle 69"
          transform="translate(892.039 559.077)"
          fill="none"
          stroke="#1a1818"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
          d="M0 0H59.912V42.52H0z"
        />
        <path
          data-name="Path 905"
          d="M896.136 562.435a1.117 1.117 0 11-1.117 1.117 1.117 1.117 0 011.117-1.117z"
          fill="none"
          stroke="#1a1818"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
        <path
          data-name="Path 906"
          d="M902.1 562.435a1.117 1.117 0 11-1.117 1.117 1.117 1.117 0 011.117-1.117z"
          fill="none"
          stroke="#1a1818"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
      </g>
    </svg>
  )
}

export default NotFoundIcon
